module.exports = __webpack_public_path__ + "static/media/appstore-6f.0b16ab28.png";